let EmailSubscribe = {
	init: function () {
		jQuery('.email-submit-form').submit(function (e) {
			e.preventDefault();
			let submitButton = jQuery(this).find('button');
			submitButton.prop("disabled", true);

			let email = jQuery(e.currentTarget[0]).val();
			let isMobile = Util.mobileAndTabletCheck();

			let dataObj = {
				"BrandId": parseInt(Util.getCookie("brand_id")),
				"IsMobile": isMobile,
				"Email": email,
				"OptedOut": false,
			};

			jQuery.ajax({
				url: Util.lambdaHost + 'email/subscribe',
				beforeSend: function (request) {
					request.setRequestHeader('x-api-key', Util.lambdaApiKey);
				},
				dataType: 'json',
				type: "POST",
				data: JSON.stringify(dataObj),
				contentType: "application/json;charset=utf-8",
				success: function (response) {
					jQuery('.email-subscribe-header').hide('slow');
					jQuery('.email-submit-form').hide('slow');
					jQuery('.email-submit-success').show('slow');
					submitButton.prop("disabled", false);
				},
				error: function (response) {
					jQuery('.email-subscribe-header').hide('slow');
					jQuery('.email-submit-form').hide('slow');
					jQuery('.email-submit-error').show('slow');
					submitButton.prop("disabled", false);
					console.log(response);
				}
			});
		});
	}
};